import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";
import tokenService from '../../Common/tokenDecoder';

export default {
    getAll,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getNormDetails,
    updateNewNorm,
    getConfigurationNames,
    NormValuesSave,
    getNormDetailsByID
};

async function getAll() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getConfigurationNames(operationEntityID) {
    let response = await CommonGet('/api/OperationEntityConfiguration/GetConfigurationNameNorm', 'operationEntityID=' + operationEntityID);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["id"]] = item[1]["configurationName"]
    }
    return groupArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function getNormDetails(data) {
    const divisionIDs = Array.isArray(data.divisionID)
        ? data.divisionID.map(id => parseInt(id)).filter(id => !Number.isNaN(id))
        : [parseInt(data.divisionID)].filter(id => !Number.isNaN(id));

    const operationEntityIDs = Array.isArray(data.estate)
        ? data.estate.map(id => parseInt(id)).filter(id => !Number.isNaN(id))
        : [parseInt(data.estate)].filter(id => !Number.isNaN(id));

    var model = {
        divisionIDs: divisionIDs,
        operationEntityIDs: operationEntityIDs,
        configurationID: parseInt(data.configurationID),
        fromDate: data.fromDate,
        toDate: data.toDate,
        isSundayEnabled: Boolean(data.isSundayEnabled),
    };
    const response = await CommonPost('/api/ChangeNorm/GetNormValues', null, model);
    return response.data;
}

async function NormValuesSave(saveData) {
    const response = await CommonPost('/api/ChangeNorm/SaveNormValues', null, saveData);
    return response;
}

async function updateNewNorm(data, normValue) {
    const divisionIDs = Array.isArray(normValue.divisionID)
        ? normValue.divisionID.map(id => parseInt(id)).filter(id => !Number.isNaN(id))
        : [parseInt(normValue.divisionID)].filter(id => !Number.isNaN(id));

    var model = {
        configurationValue: data.configurationValue == '' ? 0 : parseInt(data.configurationValue),
        minValue: parseInt(data.minValue),
        maxValue: parseInt(data.maxValue),
        divisionIDs: divisionIDs,
        configurationID: parseInt(normValue.configurationID),
        fromDate: normValue.fromDate,
        toDate: normValue.toDate,
        isSundayEnabled: Boolean(normValue.isSundayEnabled),
        modifiedBy: parseInt(tokenService.getUserIDFromToken()),
    };
    const response = await CommonPost('/api/ChangeNorm/UpdateNewNorm', null, model);
    return response;
}

async function getNormDetailsByID(configurationHistoryID) {
    let response = await CommonPost('/api/ChangeNorm/GetNormDetailsByID', "configurationHistoryID=" + parseInt(configurationHistoryID))
    return response.data;
}
